import Colors from '@utils/Colors.js'

// Tabs and Tab take their look from here. Change a value here instead of in a component.

// 'default': two lines under each tab (hover/active and the row's border). 'courier': the tabs of the courier app,
// without padding (they share a phone's width) and with one line at the bottom that thickens when active
export type TabVariant = 'default' | 'courier'

export const tabSizes = {
    // Height of the row of tabs
    height: 38,
    fontSize: {sm: 12, md: 14},
    // A tab whose content isn't a string (an icon) shows it at this size
    iconSize: 20,
    fontWeight: 500,
    letterSpacing: '.05rem',
    paddingX: {sm: 10, md: 25},
    // The two lines under a tab: the upper one shows hover and active, the lower one is the row's border
    lineHeight: 1,
    transition: 'all ease 0.2s',
    // The line of the 'courier' variant, over the bottom of the tab
    courierLineHeight: 1,
    courierLineHeightActive: 3
}

export const tabColors = {
    text: Colors.textDark,
    textActive: Colors.buttonSolid,
    textDisabled: Colors.textMedium,
    hover: Colors.grey20,
    line: Colors.border,
    lineActive: Colors.buttonSolid,
    courierLine: Colors.grey60
}
